/**
 * Lulú Fardos - Shopify Online Store 2.0 Theme JS
 * Interacciones: Carrito Lateral AJAX, Calculadora de Ganancia B2B, Menú Móvil, WhatsApp Direct
 */

(function () {
  'use strict';

  // --- Utilidades de Formato ---
  const Currency = {
    // Formatea montos en pesos chilenos (CLP) con separadores de miles con puntos y sufijo oficial
    // Ej: 800000 -> "$800.000 CLP" (o "$800.000" si withSuffix=false)
    formatCLP: function (amount, withSuffix = true) {
      const val = typeof amount === 'number' ? amount : parseFloat(amount);
      if (isNaN(val)) return withSuffix ? '$0 CLP' : '$0';
      const isNegative = val < 0;
      const absVal = Math.round(Math.abs(val));
      const formatted = absVal.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      const sign = isNegative ? '-' : '';
      const suffix = withSuffix ? ' CLP' : '';
      return `${sign}$${formatted}${suffix}`;
    },

    // Formatea montos recibidos de las APIs de Shopify (que se devuelven en centavos/multiplicados x100)
    formatShopifyCents: function (cents, withSuffix = true) {
      let val = typeof cents === 'number' ? cents : parseFloat(cents);
      if (isNaN(val)) return withSuffix ? '$0 CLP' : '$0';
      if (Math.abs(val) >= 100000) {
        val = Math.round(val / 100);
      } else if (Math.abs(val) >= 100 && val % 100 === 0) {
        val = Math.round(val / 100);
      }
      return this.formatCLP(val, withSuffix);
    },

    // Parsea de forma segura cualquier valor ingresado por el usuario en el simulador
    // Evita que "5.000" se interprete como 5 o trunque ceros al multiplicar
    // Ej: "5000" -> 5000, "5.000" -> 5000, "$5.000" -> 5000, "5.990" -> 5990
    parseCLPInput: function (val) {
      if (typeof val === 'number') return Math.round(val);
      if (!val) return 0;
      // Extrae únicamente dígitos numéricos, ignorando puntos, comas, signos $ y espacios
      const digitsOnly = val.toString().replace(/[^\d]/g, '');
      const parsed = parseInt(digitsOnly, 10);
      return isNaN(parsed) ? 0 : parsed;
    }
  };

  // --- Carrito Lateral (Drawer Cart) AJAX ---
  const CartDrawer = {
    overlay: null,
    drawer: null,
    countBadges: [],
    itemsContainer: null,
    subtotalEl: null,

    init: function () {
      this.overlay = document.getElementById('CartDrawerOverlay');
      this.drawer = document.getElementById('CartDrawer');
      this.countBadges = document.querySelectorAll('.cart-count-badge');
      this.itemsContainer = document.getElementById('CartDrawerItems');
      this.subtotalEl = document.getElementById('CartDrawerSubtotal');

      if (!this.drawer) return;

      // Event listeners para abrir y cerrar
      document.querySelectorAll('[data-cart-drawer-trigger]').forEach((trigger) => {
        trigger.addEventListener('click', (e) => {
          e.preventDefault();
          this.open();
        });
      });

      const closeBtn = document.getElementById('CartDrawerClose');
      if (closeBtn) closeBtn.addEventListener('click', () => this.close());
      if (this.overlay) this.overlay.addEventListener('click', () => this.close());

      // Interceptar formularios de añadir al carrito estándar
      document.addEventListener('submit', (e) => {
        if (e.target && e.target.matches('form[action*="/cart/add"]')) {
          e.preventDefault();
          this.handleAddToCart(e.target);
        }
      });

      // Quick add desde tarjetas de producto
      document.addEventListener('click', (e) => {
        const quickAddBtn = e.target.closest('[data-quick-add-id]');
        if (quickAddBtn) {
          e.preventDefault();
          const variantId = quickAddBtn.getAttribute('data-quick-add-id');
          this.addItem(variantId, 1, quickAddBtn);
        }
      });
    },

    open: function () {
      if (this.drawer) this.drawer.classList.add('active');
      if (this.overlay) this.overlay.classList.add('active');
      document.body.style.overflow = 'hidden';
      this.refresh();
    },

    close: function () {
      if (this.drawer) this.drawer.classList.remove('active');
      if (this.overlay) this.overlay.classList.remove('active');
      document.body.style.overflow = '';
    },

    handleAddToCart: function (form) {
      const submitBtn = form.querySelector('[type="submit"]');
      const originalText = submitBtn ? submitBtn.innerHTML : '';
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.innerHTML = '<span>Agregando fardo...</span>';
      }

      const formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then((res) => {
          if (!res.ok) throw new Error('Error al agregar el producto');
          return res.json();
        })
        .then((item) => {
          this.open();
        })
        .catch((err) => {
          console.error(err);
          alert('Hubo un problema al agregar este fardo. Consulta disponibilidad por WhatsApp.');
        })
        .finally(() => {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.innerHTML = originalText;
          }
        });
    },

    addItem: function (variantId, quantity, triggerBtn) {
      if (triggerBtn) triggerBtn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ id: variantId, quantity: quantity })
      })
        .then((res) => res.json())
        .then(() => {
          this.open();
        })
        .catch((err) => console.error(err))
        .finally(() => {
          if (triggerBtn) triggerBtn.disabled = false;
        });
    },

    refresh: function () {
      fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then((res) => res.json())
        .then((cart) => {
          this.renderCart(cart);
        })
        .catch((err) => console.error(err));
    },

    renderCart: function (cart) {
      // Actualizar contadores
      this.countBadges.forEach((badge) => {
        badge.textContent = cart.item_count;
        badge.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });

      if (this.subtotalEl) {
        this.subtotalEl.textContent = Currency.formatShopifyCents(cart.total_price);
      }

      if (!this.itemsContainer) return;

      if (cart.item_count === 0) {
        this.itemsContainer.innerHTML = `
          <div style="text-align: center; padding: 3rem 1rem; color: #A3A3A3;">
            <p style="font-size: 1.1rem; margin-bottom: 1rem; font-weight: 600;">Tu carrito mayorista está vacío</p>
            <p style="font-size: 0.85rem; margin-bottom: 2rem;">Revisa nuestro catálogo de fardos y sacos premium para comenzar.</p>
            <a href="/collections/all" class="btn btn-gold" style="font-size: 0.85rem;">Explorar Catálogo</a>
          </div>
        `;
        return;
      }

      let html = '';
      cart.items.forEach((item, index) => {
        html += `
          <div class="cart-item" data-line="${index + 1}" data-key="${item.key}">
            <img class="cart-item__image" src="${item.featured_image ? item.featured_image.url : ''}" alt="${item.title}">
            <div class="cart-item__details">
              <div>
                <h4 class="cart-item__title">${item.product_title}</h4>
                ${item.variant_title ? `<span style="font-size:0.75rem; color:#A3A3A3;">${item.variant_title}</span>` : ''}
              </div>
              <div class="cart-item__price">${Currency.formatShopifyCents(item.final_line_price)}</div>
              <div class="cart-item__controls">
                <div class="quantity-selector" style="transform: scale(0.85); transform-origin: left center;">
                  <button type="button" class="qty-btn" onclick="LuluTheme.CartDrawer.changeQty('${item.key}', ${item.quantity - 1})">-</button>
                  <span class="qty-input" style="line-height:48px;">${item.quantity}</span>
                  <button type="button" class="qty-btn" onclick="LuluTheme.CartDrawer.changeQty('${item.key}', ${item.quantity + 1})">+</button>
                </div>
                <button type="button" style="color: #EF4444; font-size: 0.78rem; text-decoration: underline; cursor:pointer;" onclick="LuluTheme.CartDrawer.changeQty('${item.key}', 0)">Eliminar</button>
              </div>
            </div>
          </div>
        `;
      });
      this.itemsContainer.innerHTML = html;
    },

    changeQty: function (lineKey, newQuantity) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ id: lineKey, quantity: newQuantity })
      })
        .then((res) => res.json())
        .then((cart) => {
          this.renderCart(cart);
        })
        .catch((err) => console.error(err));
    }
  };

  // --- Calculadora de Margen de Ganancia Mayorista B2B ---
  const ProfitCalculator = {
    init: function () {
      const calcBox = document.getElementById('B2BProfitCalculator');
      if (!calcBox) return;

      // Obtener precio oficial del lote/fardo en pesos chilenos reales
      let fardoPrice = parseFloat(calcBox.getAttribute('data-product-price-pesos') || 0);
      if (!fardoPrice || fardoPrice <= 0) {
        const rawShopifyPrice = parseFloat(calcBox.getAttribute('data-product-price') || 0);
        // En Shopify Liquid, los precios suelen expresarse con 2 decimales/centavos implícitos (ej: 8000000 -> 80.000 CLP)
        fardoPrice = rawShopifyPrice >= 100000 ? Math.round(rawShopifyPrice / 100) : rawShopifyPrice;
      }

      const estimatedUnits = Math.max(1, parseInt(calcBox.getAttribute('data-estimated-units') || 100, 10));

      const retailInput = document.getElementById('calcRetailPriceInput');
      const unitCostEl = document.getElementById('calcUnitCost');
      const totalRevenueEl = document.getElementById('calcTotalRevenue');
      const netProfitEl = document.getElementById('calcNetProfit');
      const roiEl = document.getElementById('calcROI');

      if (!retailInput || !unitCostEl || !totalRevenueEl || !netProfitEl || !roiEl) return;

      // Costo por prenda unitario
      const unitCost = Math.round(fardoPrice / estimatedUnits);
      unitCostEl.textContent = Currency.formatCLP(unitCost);

      const calculate = () => {
        // Parsear el valor digitado sin truncar ceros (soporta 5000, 5.000, $5.000, etc.)
        const retailPrice = Currency.parseCLPInput(retailInput.value);

        // FÓRMULAS OFICIALES REQUERIDAS:
        // [Ingreso Bruto = Precio Venta Público * Cantidad Unidades (~160)]
        const totalRevenue = retailPrice * estimatedUnits;

        // [Ganancia Neta = Ingreso Bruto - (Costo x Prenda * Cantidad Unidades)]
        const totalCost = unitCost * estimatedUnits;
        const netProfit = totalRevenue - totalCost;

        // Retorno sobre la inversión (ROI)
        const roi = totalCost > 0 ? Math.round((netProfit / totalCost) * 100) : 0;

        // Despliegue con formato oficial CLP con separadores de miles con puntos
        totalRevenueEl.textContent = Currency.formatCLP(totalRevenue);
        netProfitEl.textContent = Currency.formatCLP(netProfit);
        roiEl.textContent = (roi > 0 ? '+' : '') + roi.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') + '%';

        if (netProfit < 0) {
          netProfitEl.style.color = '#EF4444';
          roiEl.style.color = '#EF4444';
        } else {
          netProfitEl.style.color = '#34D399';
          roiEl.style.color = 'var(--accent-gold)';
        }
      };

      retailInput.addEventListener('input', calculate);
      retailInput.addEventListener('change', calculate);
      retailInput.addEventListener('keyup', calculate);

      // Al perder el foco (blur), dar formato amigable con puntos de miles al input si es número
      retailInput.addEventListener('blur', function () {
        const parsed = Currency.parseCLPInput(this.value);
        if (parsed > 0) {
          this.value = parsed.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        }
      });

      calculate(); // Ejecutar cálculo inicial
    }
  };

  // --- Galería de Producto (Cambio de Miniaturas) ---
  const ProductGallery = {
    init: function () {
      const thumbs = document.querySelectorAll('.gallery-thumb');
      const mainImage = document.getElementById('MainProductImage');
      if (!thumbs.length || !mainImage) return;

      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', function () {
          thumbs.forEach((t) => t.classList.remove('active'));
          this.classList.add('active');
          const newSrc = this.getAttribute('data-image-src');
          if (newSrc) {
            mainImage.src = newSrc;
          }
        });
      });
    }
  };

  // --- Acordeones Desplegables ---
  const Accordions = {
    init: function () {
      document.querySelectorAll('.accordion-trigger').forEach((trigger) => {
        trigger.addEventListener('click', function () {
          const item = this.closest('.accordion-item');
          if (!item) return;
          const isActive = item.classList.contains('active');
          
          // Cerrar otros acordeones si se desea comportamiento único
          item.classList.toggle('active', !isActive);
        });
      });
    }
  };

  // --- Menú Móvil ---
  const MobileMenu = {
    init: function () {
      const toggleBtn = document.getElementById('MobileMenuToggle');
      const mobileNav = document.getElementById('MobileNavDrawer');
      const closeBtn = document.getElementById('MobileNavClose');

      if (!toggleBtn || !mobileNav) return;

      toggleBtn.addEventListener('click', () => {
        mobileNav.classList.add('active');
        document.body.style.overflow = 'hidden';
      });

      if (closeBtn) {
        closeBtn.addEventListener('click', () => {
          mobileNav.classList.remove('active');
          document.body.style.overflow = '';
        });
      }
    }
  };

  // --- Carrusel Horizontal Desktop B2B (Exclusivo Portada) ---
  const HorizontalCarousel = {
    init: function () {
      const wrappers = document.querySelectorAll('.home-cat-block .carousel-wrapper');
      if (!wrappers.length) return;

      wrappers.forEach(wrapper => {
        const scroller = wrapper.querySelector('.product-grid');
        const leftBtn = wrapper.querySelector('.carousel-prev-btn, .carousel-arrow--left');
        const rightBtn = wrapper.querySelector('.carousel-next-btn, .carousel-arrow--right');
        if (!scroller) return;

        // Función para calcular desplazamiento equivalente a una tarjeta + gap
        const getCardStep = () => {
          const firstCard = scroller.querySelector('.product-card');
          let gap = 28.8; // 1.8rem
          if (window.getComputedStyle) {
            const compGap = parseFloat(window.getComputedStyle(scroller).gap);
            if (!isNaN(compGap) && compGap > 0) gap = compGap;
          }
          return firstCard ? (firstCard.getBoundingClientRect().width + gap) : (scroller.clientWidth / 4 + gap);
        };

        // Función para actualizar visibilidad de los botones según desborde real
        const updateArrowState = () => {
          if (window.innerWidth < 992) {
            if (leftBtn) leftBtn.style.display = 'none';
            if (rightBtn) rightBtn.style.display = 'none';
            return;
          }
          const hasOverflow = scroller.scrollWidth > scroller.clientWidth + 5;
          const displayVal = hasOverflow ? 'flex' : 'none';
          if (leftBtn) leftBtn.style.display = displayVal;
          if (rightBtn) rightBtn.style.display = displayVal;
        };

        // Función para actualizar estado de enfoque de tarjetas (efecto editorial)
        const updateCardFocus = () => {
          if (window.innerWidth < 992) {
            scroller.querySelectorAll('.product-card').forEach(card => {
              card.classList.remove('card-edge', 'card-active', 'card-inactive');
            });
            return;
          }

          const scrollerRect = scroller.getBoundingClientRect();
          const cards = scroller.querySelectorAll('.product-card');

          cards.forEach(card => {
            const cardRect = card.getBoundingClientRect();
            const visibleLeft = Math.max(scrollerRect.left, cardRect.left);
            const visibleRight = Math.min(scrollerRect.right, cardRect.right);
            const visibleWidth = Math.max(0, visibleRight - visibleLeft);
            const ratio = visibleWidth / (cardRect.width || 1);

            if (ratio >= 0.85) {
              card.classList.add('card-active');
              card.classList.remove('card-edge');
            } else {
              card.classList.remove('card-active');
              card.classList.add('card-edge');
            }
          });
        };

        // Click en la flecha derecha de navegación (avanzar)
        if (rightBtn) {
          rightBtn.addEventListener('click', (e) => {
            e.preventDefault();
            const step = getCardStep();
            const maxScroll = scroller.scrollWidth - scroller.clientWidth;
            if (scroller.scrollLeft >= maxScroll - 15) {
              scroller.scrollTo({ left: 0, behavior: 'smooth' });
            } else {
              scroller.scrollBy({ left: step, behavior: 'smooth' });
            }
          });
        }

        // Click en la flecha izquierda de navegación (retroceder)
        if (leftBtn) {
          leftBtn.addEventListener('click', (e) => {
            e.preventDefault();
            const step = getCardStep();
            const maxScroll = scroller.scrollWidth - scroller.clientWidth;
            if (scroller.scrollLeft <= 15) {
              scroller.scrollTo({ left: maxScroll, behavior: 'smooth' });
            } else {
              scroller.scrollBy({ left: -step, behavior: 'smooth' });
            }
          });
        }

        // Eventos de scroll con throttling via requestAnimationFrame
        let ticking = false;
        scroller.addEventListener('scroll', () => {
          if (!ticking) {
            window.requestAnimationFrame(() => {
              updateCardFocus();
              ticking = false;
            });
            ticking = true;
          }
        }, { passive: true });

        // Evento resize
        window.addEventListener('resize', () => {
          updateArrowState();
          updateCardFocus();
        });

        // Inicializar estados
        updateArrowState();
        updateCardFocus();
      });
    }
  };

  // --- Inicialización General al Cargar DOM ---
  document.addEventListener('DOMContentLoaded', function () {
    CartDrawer.init();
    ProfitCalculator.init();
    ProductGallery.init();
    Accordions.init();
    MobileMenu.init();
    HorizontalCarousel.init();
  });

  // Exportar al objeto global para callbacks de Liquid si es necesario
  window.LuluTheme = {
    CartDrawer: CartDrawer,
    ProfitCalculator: ProfitCalculator,
    Currency: Currency,
    HorizontalCarousel: HorizontalCarousel
  };
})();
